import { RETURN_TRIP_ETA_THRESHOLD_MINUTES, RETURN_TRIP_ALERTS } from '@/constants/ride';
import { useSwalDialog } from '@/use/swalDialog';

export const useReturnTripAlert = () => {
  const { showWarningPopupDialog } = useSwalDialog();

  /**
   * Shows appropriate alert based on return trip availability
   * @param isNoReturnTrip - Whether there are no drivers available for the return trip
   * @param returnTripEtaMins - ETA in minutes for the return trip (if available)
   * @returns Promise that resolves when the alert is dismissed (or immediately if no alert needed)
   */
  const showReturnTripAlertIfNeeded = async (isNoReturnTrip?: boolean, returnTripEtaMins?: number) => {
    if (isNoReturnTrip) {
      await showWarningPopupDialog({
        title: RETURN_TRIP_ALERTS.NO_COVERAGE.title,
        text: RETURN_TRIP_ALERTS.NO_COVERAGE.message,
      });
    } else if (returnTripEtaMins !== undefined && returnTripEtaMins >= RETURN_TRIP_ETA_THRESHOLD_MINUTES) {
      await showWarningPopupDialog({
        title: RETURN_TRIP_ALERTS.LIMITED_COVERAGE.title,
        text: RETURN_TRIP_ALERTS.LIMITED_COVERAGE.message,
      });
    }
  };

  return {
    showReturnTripAlertIfNeeded,
  };
};
